"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const ToggleButton_1 = __importDefault(require("../ToggleButton"));
const ErrorContainer = styled_components_1.default.div `
  ${(props) => props.theme.typography.variants.primary.small};
  color: ${(props) => props.theme.palette.status.error};
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;
/** Used to group related toggle buttons in forms */
function ToggleButtonGroup({ errorMessage, hasError, onChange, options, multiSelect, value, ...rest }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Collapse_1.default, { in: hasError && !!errorMessage, children: (0, jsx_runtime_1.jsxs)(ErrorContainer, { children: [(0, jsx_runtime_1.jsx)(common_buoy_icons_1.AlertIcon, { size: 14 }), errorMessage] }) }), (0, jsx_runtime_1.jsx)(ToggleButtonGroup_1.default, { exclusive: !multiSelect, fullWidth: true, onChange: onChange, orientation: "vertical", role: !multiSelect ? "radiogroup" : "group", value: value, ...rest, children: options.map((option) => ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, { hasError: hasError, multiSelect: multiSelect, role: !multiSelect ? "radio" : "checkbox", selected: value?.includes?.(option.value) || value === option.value, subText: option.subText, ...option }, `${option.label}-${option.value}`))) })] }));
}
exports.default = ToggleButtonGroup;
//# sourceMappingURL=index.js.map